import React, { useState } from 'react';
import TeamRoles from './TeamRoles';
import DocTemplates from './DocTemplates';
import IntakePromptsEditor from './IntakePromptsEditor';
import SchedulingCalendar from './SchedulingCalendar';
import CatalogCuration from './CatalogCuration';
import SalesDashboard from './SalesDashboard';
import ClientPortalSettings from './ClientPortalSettings';
import BrandAssetsSettings from './BrandAssetsSettings';
import ClassLengthSettings from './ClassLengthSettings';
import AvBoilerplateSettings from './AvBoilerplateSettings';

const SECTIONS = [
  { id: 'calendar', label: 'Calendar' },
  { id: 'catalog', label: 'Catalog', directorOnly: true },
  { id: 'sales', label: 'Sales', directorOnly: true },
  { id: 'portal', label: 'Client Portal', directorOnly: true },
  { id: 'roles', label: 'Team & Roles' },
  { id: 'templates', label: 'Doc Templates' },
  { id: 'prompts', label: 'Intake Prompts' },
  { id: 'brand', label: 'Brand Assets', directorOnly: true },
  { id: 'lengths', label: 'Class Lengths', directorOnly: true },
  { id: 'avtext', label: 'A/V Script Text', directorOnly: true },
];

export default function AdminPanel({ isDirector, initialSection }) {
  // All internal training members see the Calendar (read-only unless director/admin)
  // so they can see their tasks and the schedule. Catalog/Sales are director/admin only.
  const sections = SECTIONS.filter((s) => !s.directorOnly || isDirector);
  // Deep link from the overview, but never into a section this viewer cannot open.
  const landing = sections.some((s) => s.id === initialSection) ? initialSection : 'calendar';
  const [section, setSection] = useState(landing);
  return (
    <div className="flex gap-6">
      <nav className="w-44 shrink-0 space-y-1">
        {sections.map((s) => (
          <button key={s.id} onClick={() => setSection(s.id)}
            className={`block w-full text-left text-sm px-3 py-2 rounded-lg ${
              section === s.id ? 'bg-blue-600 text-white' : 'text-gray-500 hover:bg-blue-50 dark:hover:bg-gray-800'}`}>
            {s.label}
          </button>
        ))}
      </nav>
      <div className="flex-1 min-w-0">
        {section === 'calendar' && <SchedulingCalendar canEdit={isDirector} />}
        {section === 'catalog' && isDirector && <CatalogCuration />}
        {section === 'sales' && isDirector && <SalesDashboard />}
        {section === 'portal' && isDirector && <ClientPortalSettings />}
        {section === 'roles' && <TeamRoles />}
        {section === 'templates' && <DocTemplates />}
        {section === 'prompts' && <IntakePromptsEditor />}
        {section === 'brand' && isDirector && <BrandAssetsSettings />}
        {section === 'lengths' && isDirector && <ClassLengthSettings />}
        {section === 'avtext' && isDirector && <AvBoilerplateSettings />}
      </div>
    </div>
  );
}
